/**
 * normalizeWebsiteInput — shared canonical URL prep for every website
 * input across OrangeBySite (HQ Single Scan, HQ Bulk Scan, public Optimise
 * scan, contact form current-website field).
 *
 * Behaviour:
 *   • trims whitespace
 *   • if no scheme → prepends "https://" (backend url_guard tries HTTPS
 *     first, falls back to HTTP where the site only supports HTTP)
 *   • preserves any explicit http:// or https:// scheme
 *   • returns null for genuinely empty input
 *
 * Do NOT re-implement this per-component. Deliberately permissive on the
 * client side; the authoritative validator is `services/optimise/url_guard.py`
 * on the backend (rejects private IPs, metadata endpoints, etc).
 */
export function normalizeWebsiteInput(raw) {
  const s = (raw || "").trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  return `https://${s}`;
}

/** Cheap client-side sanity check — a single dot in a valid host segment. */
export function looksLikeDomain(raw) {
  const s = (raw || "").trim().replace(/^https?:\/\//i, "").split("/")[0];
  // Accept "example.com", "sub.example.co.uk", "www.example.io".
  return /^[a-z0-9-]+(\.[a-z0-9-]+)+$/i.test(s);
}
